(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractDetailController', ContractDetailController);

    ContractDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity', 'PDFExportService', 'category', 'ToastrService', 'ContractDTO',
                    'ContractDTOCustomService', 'ContractCustomService', 'PricingCustomService', 'CommentCustomService', 'AttachmentCustomService', 'MiscService'];

    function ContractDetailController($scope, $rootScope, previousState, entity, PDFExportService, category, ToastrService, ContractDTO,
                     ContractDTOCustomService, ContractCustomService, PricingCustomService, CommentCustomService, AttachmentCustomService, MiscService) {
        var vm = this;

        vm.contract = entity;
        var contractId = vm.contract.id;

        vm.category = category;
        vm.previousState = previousState.name;
        if (!vm.contract.type) {
            vm.contract.type = vm.category.type;
        }

        vm.shipments = [];
        vm.lots = [];
        vm.lotsAvailable = [];
        vm.lotsAllocated = [];
        vm.lotsShipped = [];
        vm.lotTotals = {};
        vm.invoices = [];
        vm.pricings = [];
        vm.plannedShipments = [];

        vm.loadFixations = loadFixations;
        vm.setPrecision = setPrecision;
        vm.calculateFixationsTotals = calculateFixationsTotals;
        vm.toFixed = toFixed;
        vm.nl2br = MiscService.nl2br;

        vm.commentList = [];
        vm.showComment = false;
        vm.attachmentList = [];
        vm.showAttachment = false;
        resolveLazyStuff(contractId);
        returnContractPricing(contractId);
        vm.returnPricingUnfixedBalance = returnPricingUnfixedBalance;
        vm.downloadAttachment = downloadAttachment;

        var unsubscribe = $rootScope.$on('ccsTrApp:contractUpdate', function (event, result) {
            vm.contract = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function getShipments( id ) {
            ContractDTOCustomService.getShipments(id).then(function (data) {
                vm.shipments = data.data;
            }, function (error) {
                console.log(error.status, error.statusText);
                vm.shipments = [];
            });
        }

        function getLots( id ) {
            ContractDTOCustomService.getLots(id).then(function (data) {
                vm.lots = data.data;
                initLotTotals();
                distributeLots( vm.lots );
            }, function (error) {
                console.log(error.status, error.statusText);
                vm.lots = [];
            });
        }

        function distributeLots( lots ) {
            vm.lotsAvailable.length = 0;
            vm.lotsAllocated.length = 0;
            vm.lotsShipped.length = 0;
            angular.forEach( lots, function( value, key ) {
                switch( value.lotStatus ) {
                    case 'AVAILABLE':
                        vm.lotsAvailable.push(value);
                        vm.lotTotals.availableBaleTotal += value.lotQtyBales;
                        vm.lotTotals.availableMtTotal += value.lotWeightMt;
                        break;
                    case 'ALLOCATED':
                        vm.lotsAllocated.push(value);
                        vm.lotTotals.allocatedBaleTotal += value.lotQtyBales;
                        vm.lotTotals.allocatedMtTotal += value.lotWeightMt;
                        break;
                    case 'SHIPPED':
                        vm.lotsShipped.push(value);
                        vm.lotTotals.shippedBaleTotal += value.lotQtyBales;
                        vm.lotTotals.shippedMtTotal += value.lotWeightMt;
                        break;
                }
            });
        }

        function toFixed(value, n) {
            return MiscService.toFixed(value, n);
        }

        function initLotTotals() {
            vm.lotTotals = {
                availableBaleTotal: 0,
                availableMtTotal: 0,
                allocatedBaleTotal: 0,
                allocatedMtTotal: 0,
                shippedBaleTotal: 0,
                shippedMtTotal: 0
            }
        }

        function getInvoices( id ) {
            ContractDTOCustomService.getInvoices(id).then(function (data) {
                vm.invoices = data.data;
            }, function (error) {
                console.log(error.status, error.statusText);
                vm.invoices = [];
            });
        }

        function returnContractPricing( id ) {
            if (vm.contract.contractPriceModel === 'ONCALL') {
                ContractCustomService.returnContractPricing(id).then(function (data) {
                    vm.pricings = data.data;
                    for (var i = 0; i < vm.pricings.length; i++) {
                        vm.loadFixations(vm.pricings[i]);
                    }
                }, function (error) {
                    console.log(error.status, error.statusText);
                    vm.pricings = [];
                });
            }
        }

        function returnPricingUnfixedBalance(value) {
            return value === null ? "0" : value;
        }

        function loadFixations(pricing) {
            PricingCustomService.getFixationsByPricing(pricing.id).then(function (data) {
                pricing.fixations = data.data;
                vm.calculateFixationsTotals(pricing);
            }, function (error) {
                console.log(error.status, error.statusText);
                pricing.fixations = [];
            });
        }

        function calculateFixationsTotals(pricing) {
            pricing.totals = {
                quantity: 0,
                futurePrice: 0,
                appliedQtyInInvoice: 0,
                finalPriceFixationAmount: 0,
                interCompAmount: 0,
                quantityFuturePrice: 0,
                quantityInterCompAmount: 0,
                quantityFinalPriceFixationAmount: 0,
                finalPriceFixationAmountAvgWeighted: 0,
                futurePriceAvgWeighted: 0,
                interCompAmountAvgWeighted: 0
            };
            if (pricing.fixations && pricing.fixations.length > 0) {
                for (var i = 0; i < pricing.fixations.length; i++) {
                    pricing.totals.quantity += pricing.fixations[i].quantity;
                    pricing.totals.futurePrice += pricing.fixations[i].futurePrice;
                    pricing.totals.appliedQtyInInvoice += pricing.fixations[i].appliedQtyInInvoice;
                    pricing.totals.finalPriceFixationAmount += pricing.fixations[i].finalPriceFixationAmount;
                    // pricing.totals.interCompAmount += pricing.fixations[i].interCompAmount;
                    pricing.totals.interCompAmount += pricing.fixations[i].interCompPrice;
                    pricing.totals.quantityFuturePrice += pricing.fixations[i].quantity * pricing.fixations[i].futurePrice;
                    // pricing.totals.quantityInterCompAmount += pricing.fixations[i].quantity * pricing.fixations[i].interCompAmount;
                    pricing.totals.quantityInterCompAmount += pricing.fixations[i].quantity * pricing.fixations[i].interCompPrice;
                    pricing.totals.quantityFinalPriceFixationAmount += pricing.fixations[i].quantity * pricing.fixations[i].finalPriceFixationAmount;
                }
                pricing.totals.futurePriceAvgWeighted = roundUp(pricing.totals.quantityFuturePrice / pricing.totals.quantity, 2);
                pricing.totals.finalPriceFixationAmountAvgWeighted = roundUp(pricing.totals.quantityFinalPriceFixationAmount / pricing.totals.quantity ,2);
                pricing.totals.interCompAmountAvgWeighted = roundUp(pricing.totals.quantityInterCompAmount / pricing.totals.quantity ,2);
            }
        }

        function roundUp(value, scale) {
            return (Math.round(value * 100) / 100).toFixed(scale);
        }

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };

        vm.download = function (id, contractNum) {
            PDFExportService.downloadContractPDF(id).then(function (data, status, headers, config) {
                var file = new Blob([data.data], {type: 'application/pdf'});
                saveAs(file, contractNum + '.pdf');
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Cannot download PDF", "Error");
                }
                console.log(error.message);
            });
        };

        vm.downloadFixation = function (id, contractNum) {
            PDFExportService.downloadFixationPDF(id).then(function (data) {
                var file = new Blob([data.data], {type: 'application/pdf'});
                saveAs(file, "Fixation-" + contractNum + ".pdf");
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Cannot download Fixation PDF", "Error");
                }
                console.log(error.message);
            });
        };

        vm.getOrDash = function (val) {
            return (val && val !== null) ? val : '-';
        };

        vm.updateContract = updateContract;
        vm.refreshContract = refreshContract;

        function updateContract() {
            var data = {
                heading: 'Edit ' + vm.contract.contractNum,
                route: vm.category.type === "PURCHASE" ? 'purchase.edit' : 'sale.edit',
                id: contractId,
                param: {id: ''}
            };
            $rootScope.$emit('handleEmit', data);
        }

        function refreshContract() {
            refetchContract(contractId);
            resolveLazyStuff(contractId);
        }

        function refetchContract(id) {
            ContractDTO.get({id: id}).$promise.then(function (data) {
                vm.contract = data;
                ToastrService.success("Contract Refreshed", "Success!");
                returnContractPricing(id);
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Failed to fetch Contract: " + error.statusText, "Error");
                }
                console.log(error.statusText);
            });
        }

        function resolveLazyStuff(id) {
            resolveComments(id);
            resolveAttachments(id);
            getShipments(id);
            getLots(id);
            getInvoices(id);
            resolvePlannedShipments(id);
        }

        function resolveComments(id) {
            vm.showComment = false;
            vm.commentList.length = 0;
            CommentCustomService.returnCommentsByContract(id).then(function (data) {
                vm.commentList = data.data;
                if (vm.commentList.length > 0) {
                    vm.showComment = true;
                    // ToastrService.success("Grabbed Comments", "Success!");
                }
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Failed to fetch comments: " + error.statusText, "Error");
                }
                console.log(error.statusText);
            });
        }

        function resolveAttachments(id) {
            vm.showAttachment = false;
            vm.attachmentList.length = 0;
            AttachmentCustomService.returnAttachmentsByContract(id).then(function (data) {
                vm.attachmentList = data.data;
                if (vm.attachmentList.length > 0) {
                    vm.showAttachment = true;
                    // ToastrService.success("Grabbed Attachments", "Success!");
                }
            }, function (error) {
                if (error.status !== 404) {
                    ToastrService.error("Failed to fetch attachments: " + error.statusText, "Error");
                }
                console.log(error.statusText);
            });
        }

        function resolvePlannedShipments( id ) {
            ContractCustomService.getPlannedShipmentsByContract(id).then( function( data ) {
                vm.plannedShipments = data.data;
                if( vm.plannedShipments.length > 0 ) {
                    // ToastrService.success("Successfully fetch Planned Shipments", "Success!");
                }
            }, function( error ) {
                if( error.status !== "404" ) {
                    ToastrService.error("Failed to get Planned Shipments for Contract", "Error!");
                }
            });
        }

        function setPrecision(originalValue, scale) {
            return parseFloat(originalValue).toFixed(scale);
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot download Attachment: " + error.statusText, "Error");
                }
            });
        }
    }
})();
